export default __webpack_public_path__ + "static/media/carInspectionImg.b788b11e.png";